import { useTranslation } from "react-i18next";
import { Box, Container, Flex, Text } from "@chakra-ui/react";

const SectionTitle = ({ children }) => (
    <Text
        fontWeight={700}
        fontSize={'18px'}
        lineHeight={'28px'}
        color={'#1E1517'}
        mt={'8px'}
    >
        {children}
    </Text>
);

const SectionStep = ({ children }) => (
    <Text
        fontWeight={400}
        fontSize={'15px'}
        lineHeight={'26px'}
        color={'#3B3033'}
    >
        {children}
    </Text>
);

const HowItWorks = () => {
    const { t } = useTranslation("how-it-works");

    const sections = [
        {
            title: 'participant.title',
            steps: [
                'participant.step1',
                'participant.step2',
                'participant.step3',
                'participant.step4',
            ],
        },
        {
            title: 'organizer.title',
            steps: [
                'organizer.step1',
                'organizer.step2',
                'organizer.step3',
                'organizer.step4',
            ],
        },
    ];

    return (
        <>
            <Box w={'full'} fontFamily="body">
                <Container maxW={'7xl'} py={'64px'}>
                    <Flex flexDirection={'column'} gap={'8px'}>

                        {/* Nagłówek strony */}
                        <Text
                            fontWeight={700}
                            fontSize={'26px'}
                            lineHeight={'38px'}
                            color={'#1E1517'}
                            textAlign={'center'}
                            mb={'4px'}
                        >
                            {t('page_title')}
                        </Text>

                        {/* Separator */}
                        <Flex w={'full'} h={'1px'} bg={'#ECE4E4'} mb={'32px'} mt={'24px'} />

                        {/* Sekcje */}
                        <Flex gap={'32px'} flexDirection={'column'} w={'full'}>
                            {sections.map((section) => (
                                <Flex key={section.title} flexDirection={'column'} gap={'12px'}>
                                    <SectionTitle>
                                        {t(section.title)}
                                    </SectionTitle>
                                    {section.steps.map((stepKey) => (
                                        <SectionStep key={stepKey}>
                                            {t(stepKey)}
                                        </SectionStep>
                                    ))}
                                </Flex>
                            ))}
                        </Flex>

                    </Flex>
                </Container>
            </Box>
        </>
    );
};

export default HowItWorks;
